var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgFullScreen = function SvgFullScreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 22 20",
    fill: "#851A92",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.468 12.09h-1.94l-.064 4.008-5.496-5.56-1.422 1.358 5.495 5.56h-4.008v2.004h7.37l.065-7.37ZM.715 12.025l1.94.065v3.944l5.56-5.496 1.421 1.422-5.624 5.496H8.02v2.004H.65l.065-7.435ZM.65 7.435h2.004V3.427l5.56 5.495L9.572 7.5 4.076 2.004H8.02V0L.65.065v7.37ZM21.533 7.435h-2.004V3.427l-5.56 5.495L12.61 7.5l5.56-5.496h-4.008V0l7.37.065v7.37Z"
  })));
};

export default SvgFullScreen;